import { get } from '@/tools/http';

const sessionsMock = {
    items: [
        {
            id: "677f7bed-acfb-4273-b3b4-ff58a0fc8698",
            activityId: "677f7bed-acfb-4273-b3b4-ff58a0fc8698",
            score: 20,
            maxScore: 50,
            testingDatetimeBegin: "2021-01-02T03:34:24.227Z",
            testingDatetimeEnd: "2021-01-02T03:34:24.227Z",
            numberAnswers: 5,
            numberQuestions: 5,
            status: "completed",
            testName: "Первый тест первая сессия",
            results: [
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
                {
                    key: 16,
                    description: "Лесоруб",
                },
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
            ],
            foreignType: "string",
        },
        {
            id: "677f7bed-afdb-5573-b3b4-ff58a0fc8698",
            activityId: "677gtyed-acfb-4273-b3b4-ff58a0fc8698",
            score: 100,
            maxScore: 100,
            testingDatetimeBegin: "2021-01-18T03:34:24.227Z",
            testingDatetimeEnd: "2021-01-18T03:34:24.227Z",
            numberAnswers: 15,
            numberQuestions: 15,
            status: "completed",
            testName: "Второй тест первая сессия",
            results: [
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
                {
                    key: 16,
                    description: "Лесоруб",
                },
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
            ],
            foreignType: "string",
        },
        {
            id: "677f7bed-acfb-4273-b3b4-ff58a0fc8699",
            activityId: "677f7bed-acfb-4273-b3b4-ff58a0fc8698",
            score: 20,
            maxScore: 50,
            testingDatetimeBegin: "2021-01-10T03:34:24.227Z",
            testingDatetimeEnd: "2021-01-10T03:34:24.227Z",
            numberAnswers: 5,
            numberQuestions: 5,
            status: "completed",
            testName: "Первый тест вторая сессия",
            results: [
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
                {
                    key: 16,
                    description: "Лесоруб",
                },
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
            ],
            foreignType: "string",
        },
        {
            id: "677f7bed-acfb-4273-b3b4-ggt8a0fc8698",
            activityId: "677f7bed-acfb-4273-ytt-ff58a0fc8698",
            score: 70,
            maxScore: 90,
            testingDatetimeBegin: "2021-01-08T03:34:24.227Z",
            testingDatetimeEnd: "2021-01-08T03:34:24.227Z",
            numberAnswers: 52,
            numberQuestions: 57,
            status: "in_check",
            testName: "Третий тест первая сессия",
            results: [
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
                {
                    key: 16,
                    description: "Лесоруб",
                },
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
            ],
            foreignType: "string",
        },
        {
            id: "677f7bed-acfb-4273-b3b4-ggt8a0fc7788",
            activityId: "677f7bed-acfb-4273-ytt-ff58a0fc8698",
            score: 70,
            maxScore: 90,
            testingDatetimeBegin: "2021-01-11T03:34:24.227Z",
            testingDatetimeEnd: "2021-01-11T03:34:24.227Z",
            numberAnswers: 52,
            numberQuestions: 57,
            status: "in_check",
            testName: "Третий тест вторая сессия",
            results: [
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
                {
                    key: 16,
                    description: "Лесоруб",
                },
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
            ],
            foreignType: "string",
        },
        {
            id: "677f7bed-acfb-4273-b3b4-ggt8a0fc7782",
            activityId: "677f7bed-acfb-4273-ytt-ff58a0fc8698",
            score: 70,
            maxScore: 90,
            testingDatetimeBegin: "2021-01-19T03:34:24.227Z",
            testingDatetimeEnd: "2021-01-19T03:34:24.227Z",
            numberAnswers: 52,
            numberQuestions: 57,
            status: "in_check",
            testName: "Третий тест третья сессия",
            results: [
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
                {
                    key: 16,
                    description: "Лесоруб",
                },
                {
                    key: null,
                    description: "<h2>Заголовок</h2><p>Подробное описание</p>",
                },
            ],
            foreignType: "string",
        },
    ],
    total: 6,
};

export default {
    namespaced: true,

    state: {
        sessions: [],
        sessionsCount: 0,
    },

    mutations: {
        setSessions(state, sessions) {
            state.sessions = sessions;
        },

        setSessionsCount(state, count) {
            state.sessionsCount = count;
        },
    },

    actions: {
        async loadSessions({ commit }, params = {}) {
            let items = sessionsMock.items;
            let count = 0;
            try {
                const answer = await get('examination', 'sessions', params);
                if (answer) {
                    items = answer.items;
                    count = answer.total || 0;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setSessions', items);
                commit('setSessionsCount', count);
            }
        },
    },

    getters: {
        getSessions: state => state.sessions,
        getLastSessions: state => {
            const groupedAndUniq = state.sessions.reduce((res, curr) => {
                if (!res[curr.activityId]) {
                    res[curr.activityId] = curr;
                } else {
                    const resDate = new Date(res[curr.activityId].testingDatetimeEnd);
                    const currDate = new Date(curr.testingDatetimeEnd);

                    res[curr.activityId] = resDate < currDate ?
                        curr : res[curr.activityId];
                }
                return res;
            }, {});
            return Object.values(groupedAndUniq);
        },
        getSessionsCount: state => state.sessionsCount,
        getLastSessionsByStatuses: (state, getters) => statuses => {
            return statuses.length ?
                getters.getLastSessions.filter(el => {
                    return statuses.includes(el.status);
                }) :
                getters.getLastSessions;
        },
    },
};
